<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    clearable
    @change="handleChange"
    :loading="loading"
    placeholder="搜索并选择"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name + (item.name_en ? `（${item.name_en}）` : '')"
      :value="item.id"
    ></el-option>
  </el-select>
</template>
<script>
import { userList } from '../../service/getData'
import { isMobile } from '@/util/index'
export default {
  props: {
    val: '',
  },
  watch: {
    val: function (v) {
      if (!v || v == 0) {
        this.selected = null
      } else {
        this.selected = v
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()

    if (this.val == 0) {
      this.selected = null
    } else if (this.val > 0) {
      this.requestDefaultUser()
    }
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        },
      )
    })
  },
  methods: {
    handleChange() {
      this.$emit('change', parseInt(this.selected) || 0)
    },
    async requestDefaultUser() {
      let res = await userList({ user_id: this.val })
      if (this.lists.filter((i) => i.id == this.val).length == 0) {
        this.lists = this.lists.concat(res.data.list)
      }
      this.selected = this.val
    },
    async requestData(query) {
      this.loading = true
      let data = {
        query: query || '',
        page: 0,
        role_name: '电话销售',
        size: 20,
        all_resource: true,
      }
      let res = await userList(data)
      this.loading = false
      this.lists = res.data.list
    },
  },
}
</script>